import React from 'react';
import { Spinner } from 'react-bootstrap';

import Tag from 'components/DesignSystem/Tag';
import { formatDate } from 'components/Admin/Products/Line';
import { getPrimaryElements } from 'components/Admin/Users/UserRow/Details/utils';
import { availabilityTagTypeMap } from 'helper/products';
import { ListedUser } from 'helper/users';
import { ResponseError } from 'services/api/base';
import { useGetUserQuery } from 'services/api/users';
import contractDate from 'utils/contractDate';
import useHandleRequestErrors from 'utils/hooks/useHandleRequestErrors';

import './index.scss';

export default function Details({ user }: { user: ListedUser }) {
  const { data: userData, error, isLoading } = useGetUserQuery({ id: user.id });
  useHandleRequestErrors(error as ResponseError);

  if (isLoading) {
    return (
      <div className="users-mobile-details-loading">
        <Spinner animation="border" size="sm" />
        <span>Carregando detalhes…</span>
      </div>
    );
  }

  const phones = userData?.phones || [];
  const cpf = userData?.cpf || 'Não informado';
  const emails = userData?.emails || [];
  const productsCount = user.products.length;

  return (
    <div className="users-mobile-details">
      <p className="users-mobile-details-title">Informações pessoais</p>
      <div className="users-mobile-details-rows">
        <div className="users-mobile-details-row">
          <span>Telefone</span>
          <span>{getPrimaryElements(phones, 'phone')}</span>
        </div>
        <div className="users-mobile-details-row">
          <span>CPF</span>
          <span>{cpf}</span>
        </div>
        <div className="users-mobile-details-row">
          <span>E-mail</span>
          <span className="users-mobile-details-email">{getPrimaryElements(emails, 'email')}</span>
        </div>
      </div>

      <p className="users-mobile-details-title">Contrato</p>
      <div className="users-mobile-details-contract">
        <div className="users-mobile-details-contract-card">
          <span>Início</span>
          <p>{contractDate(user.dt_inicio)}</p>
        </div>
        <div className="users-mobile-details-contract-card">
          <span>Fim</span>
          <p>{contractDate(user.dt_fim)}</p>
        </div>
      </div>

      <div className="users-mobile-details-products-header">
        <p className="users-mobile-details-title">Produtos</p>
        <span>{`${productsCount} produto${productsCount === 1 ? '' : 's'}`}</span>
      </div>
      <div className="users-mobile-details-products">
        {user.products.map((product) => (
          <div key={product.name} className="users-mobile-details-product">
            <Tag type={availabilityTagTypeMap[product.availability]}>{product.acronym}</Tag>
            <span className="users-mobile-details-product-name">{product.name}</span>
            <span className="users-mobile-details-product-period">
              {`${formatDate(product.startDateString)} - ${formatDate(product.endDateString)}`}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
